import { faAddressCard, faFolder } from "@fortawesome/free-regular-svg-icons";
import { faCalendar, faClipboard, faFolderOpen, faStar, faUser } from "@fortawesome/free-regular-svg-icons";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { routes } from "../../routes";

const menuLinks = [
  { caption: "Home", route: routes.home, icon: faHouse },
  { caption: "Dashboard", route: routes.dashboard.base, icon: faStar },
  { caption: "Projects", route: routes.project.list, icon: faFolderOpen },
  { caption: "Scopes of Work", route: routes.scopeOfWork.list(), icon: faFolder },
  { caption: "Welders", route: routes.welder.list(), icon: faUser },
  { caption: "Test Events", route: routes.testEvent.list, icon: faCalendar },
  { caption: "Contractors", route: routes.contractor.list, icon: faAddressCard },
  { caption: "Standard Tests", route: routes.standardTests.list, icon: faClipboard },
];

export function SideMenu() {
  return (
    <div className="list-group">
      <h5 className="list-group-item bg-light p-2 ps-3">Navigation</h5>
      {menuLinks.map((link) => (
        <Link to={link.route} key={link.route} className="list-group-item list-group-item-action text-dark">
          <FontAwesomeIcon icon={link.icon} fixedWidth />
          <span className="ms-3">{link.caption}</span>
        </Link>
      ))}
    </div>
  );
}
